function removeProductToWishlist(customer_email, product_id, wishlist_id, shop) {
    var dataInfo = {
        customer: customer_email,
        product: product_id,
        wishlist: wishlist_id,
        shop: shop,
    };
    return $.ajax({
        url: 'https://wishlist.onlinestatusindicator.com/api/wishlistremovecust',
        type: 'POST',
        data: dataInfo,
        dataType: 'json',
        cache: true,
        success: function (data) {
            return true;
        },
        error: function (xhr, resp, text) {
            console.log(xhr, resp, text);
            return false;
        },
    });
}

$(document).ready(function () {
    // Change event button wishlist
    $('.onstwishlistbtnbox button').click(function () {
        if ($(this).attr('data-login') == 'already') {
            var customer_email = $(this).attr('data-customer');
            var product_id = $(this).attr('data-id');
            var wishlist_id = $(this).next().val();
            var shop = $(this).next().next().val();

            if (removeProductToWishlist(customer_email, product_id, wishlist_id, shop)) {
                $(this).attr('data-login', 'wishlist');
            }
        }
    });

    // Hide button wishlist when product is sanding or _sustainability
    $('input[name="product-type"]').each(function () {
        if ($(this).val() === 'sanding' || $(this).val() === '_sustainability' || $(this).val() === 'maintenance') {
            $('.onstwishlistbtnbox').hide();
        }
    });

    // Add linebreak to badge
    $('.price__badge-sold-out').before('<br>');

});
